// Reporte le libellé de chaque colonne (<thead> th) sur les <td> via
// data-label, utilisé en CSS pour l'affichage "cartes" des tableaux sous la
// tablette (cf. src/scss/components/molecules/_table.scss).
const tables = {
  load() {
    document.querySelectorAll("table").forEach((table) => {
      if (table.dataset.labelsReady) return;

      const headers = table.querySelectorAll("thead th");
      if (!headers.length) return;

      const labels = Array.from(headers).map((th) => th.textContent.trim());

      table.querySelectorAll("tbody tr").forEach((row) => {
        row.querySelectorAll("td").forEach((cell, index) => {
          if (labels[index]) cell.setAttribute("data-label", labels[index]);
        });
      });

      table.dataset.labelsReady = "1";
    });
  },
};

export default tables;
